module.exports = __webpack_public_path__ + "img/home-con-img.fb3eaad7.png";